import { ArrowFlag } from 'components/arrowFlag/arrowFlag';
import React from 'react';
import PropTypes from 'prop-types';
import './joinHolderRow.scss';

export const JoinHolderRow = ({ name, type }) => {
    return (
        <div className="joinHolder-row">
            <span>{name}</span>
            <ArrowFlag text={type} borderColor="grey" />
        </div>
    );
};

JoinHolderRow.propTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
};
